<div class="menu-content">
  <div class="menu-top">
    <h2 class="ml-lg mb-lg">{{ 'menu.title' | translate }}</h2>

    <ion-list class="menu-list" lines="none">
      <ion-item button class="menu-item" (click)="navigate('/home')">
        <ion-label>{{ 'menu.home' | translate }}</ion-label>
      </ion-item>

      <ion-item button class="menu-item" (click)="navigate('/houses')">
        <ion-label>{{ 'menu.houses' | translate }}</ion-label>
      </ion-item>

      <ion-item button class="menu-item" (click)="navigate('/orders')">
        <ion-label>{{ 'menu.orders' | translate }}</ion-label>
      </ion-item>

      <ion-item button class="menu-item" (click)="navigate('/payments-and-invoices')">
        <ion-label>{{ 'menu.payments-and-invoices' | translate }}</ion-label>
      </ion-item>

      <ion-item
        button
        class="menu-item"
        (click)="navigate('/where-to-dropoff-laundry')"
      >
        <ion-label>{{ 'menu.where-to-drop-off-laundry' | translate }}</ion-label>
      </ion-item>

      <ion-item button class="menu-item" (click)="navigate('/faq')">
        <ion-label>{{ 'menu.faq' | translate }}</ion-label>
      </ion-item>

      <ion-item button class="menu-item" (click)="navigate('/account')">
        <ion-label>{{ 'menu.my-account' | translate }}</ion-label>
      </ion-item>

      @if (contactService.contact()) {
        <ion-item button class="menu-item" (click)="navigate('/contact')">
          <ion-label>{{ 'menu.my-contact' | translate }}</ion-label>
        </ion-item>
      }
    </ion-list>
  </div>

  <ion-button
    class="logout-button"
    fill="clear"
    shape="round"
    color="danger"
    expand="block"
    mode="ios"
    (click)="logout()"
  >
    <ion-icon
      name="power-outline"
      size="small"
      slot="end"
      color="danger"
      aria-hidden="true"
    ></ion-icon>
    {{ 'common.actions.logout' | translate }}
  </ion-button>
</div>
